<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-btn @click="onAddAnswer">
        {{$t('poll.addAnswer')}}
      </v-btn>
    </v-flex>
    <v-flex xs12
      v-for="(ans, index) in item.values"
      :key="ans.id"
    >
      <translate
        v-model="ans.answer"
        :languages="languages"
        :label="$t('poll.answer') + ' ' + (index + 1)"
        @input="handleChangeIsModified"
      />
    </v-flex>
  </v-layout>
</template>
<script>
  import Translate from '@/components/Translate'
  export default {
    components: {
      Translate
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      onAddAnswer: {
        type: Function,
        required: true
      },
      onChangeIsModified: {
        type: Function,
        required: true
      }
    },
    computed: {
      languages () {
        return this.$store.state.app.Languages
      },
    },
    methods: {
      handleChangeIsModified () {
        this.onChangeIsModified()
      }
    }
  }
</script>